import { ObjectValues } from '@stadionhq-v3/core';
import { CONTENT_TYPE_IDS } from '@core/constants/contentTypes.constants';
import type { Locale } from '@core/constants/locales.constants';
import { PATHNAMES } from './pathnames';
/**
 * Routes's values should match exactly the file system naming
 * En is the default locale
 */
/**
 * Routes's values should match exactly the file system naming
 */
export const routes = PATHNAMES.default;

export type Route = ObjectValues<typeof routes>;

export type RevalidatePathPayload = {
  contentType: ObjectValues<typeof CONTENT_TYPE_IDS>;
  id: string;
};

export type RevalidateTagPayload = {
  contentType: ObjectValues<typeof CONTENT_TYPE_IDS>;
  // Entry id — present when the Contentful tag webhook is configured to send
  // it. Drives narrow `${contentType}:${id}` invalidation; when absent we
  // fall back to broad content-type tags only.
  id?: string;
};

export type RevalidatePathParams = {
  id: string;
  locale: Locale;
};
